export class FittingProductModel {
    public remoteId: number;
    public article: string;
    public diameter: number;
    public count: number;
}